import { render } from "./selectAndBuyOffers.vue?vue&type=template&id=0e8f99fa&ts=true"
import script from "./selectAndBuyOffers.vue?vue&type=script&lang=ts"
export * from "./selectAndBuyOffers.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__